import React, { useState, useEffect } from 'react';
import Header from '../master/SideBar';
import Nav from '../master/NavBar';
import AcademicHeader from './AcademicHeader';

const HomeWork = () => {
    const [loading, setLoading] = useState(false);
    const [homeworks, setHomeworks] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingHomework, setEditingHomework] = useState(null);
    const [formData, setFormData] = useState({
        title: '',
        subject: '',
        dueDate: '',
        description: ''
    });

    // Simulate fetching data from API
    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setHomeworks([
                {
                    id: 1,
                    title: 'Math Assignment',
                    subject: 'Mathematics',
                    dueDate: '2025-11-10',
                    description: 'Complete chapter 5 exercises'
                },
                {
                    id: 2,
                    title: 'Science Report',
                    subject: 'Science',
                    dueDate: '2025-11-12',
                    description: 'Write a report on renewable energy sources'
                }
            ]);
            setLoading(false);
        }, 1000);
    }, []);

    // Handle modal open for add or edit
    const handleOpenModal = (homework = null) => {
        if (homework) {
            setEditingHomework(homework);
            setFormData({
                title: homework.title,
                subject: homework.subject,
                dueDate: homework.dueDate,
                description: homework.description
            });
        } else {
            setEditingHomework(null);
            setFormData({
                title: '',
                subject: '',
                dueDate: '',
                description: ''
            });
        }
        setShowModal(true);
    };

    // Close modal
    const handleCloseModal = () => setShowModal(false);

    // Handle form change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle add/update submit
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        setTimeout(() => {
            if (editingHomework) {
                // Update
                setHomeworks((prev) =>
                    prev.map((hw) =>
                        hw.id === editingHomework.id ? { ...hw, ...formData } : hw
                    )
                );
            } else {
                // Add
                setHomeworks((prev) => [
                    ...prev,
                    { id: Date.now(), ...formData }
                ]);
            }
            setLoading(false);
            setShowModal(false);
        }, 800);
    };

    // Handle delete
    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this homework?')) {
            setHomeworks(homeworks.filter((hw) => hw.id !== id));
        }
    };

    return (
        <>
             {loading && (
                    <div
                      className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
                      style={{ zIndex: 9999 }}
                    >
                      <div className="sk-chase sk-primary display-1">
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                      </div>
                    </div>
                  )}
            
                  <div className="layout-wrapper layout-content-navbar">
                    <div className="layout-container">
                      <Header />
                      <div className="layout-page">
                        <Nav />
            
                        <div className="container-fluid mt-2">
                          <div className="row custom-scroll-layout">
                            <div className="col-md-2 left-pane">
                              <AcademicHeader data={"Academic Portal"} />
                            </div>
                            <div className="col-md-10 right-pane">
                              <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h3>Homework List</h3>
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => handleOpenModal()}
                                            >
                                                + Add Homework
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card mt-3">
                                    <div className="card-body">


                                        {homeworks.length === 0 ? (
                                            <p className="text-muted">No homework available.</p>
                                        ) : (
                                            <table className="table table-hover text-center">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Title</th>
                                                        <th>Subject</th>
                                                        <th>Due Date</th>
                                                        <th>Description</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {homeworks.map((hw, index) => (
                                                        <tr key={hw.id}>
                                                            <td>{index + 1}</td>
                                                            <td>{hw.title}</td>
                                                            <td>{hw.subject}</td>
                                                            <td>{hw.dueDate}</td>
                                                            <td>{hw.description}</td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-sm btn-info me-2"
                                                                    onClick={() => handleOpenModal(hw)}
                                                                >
                                                                    Edit
                                                                </button>
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => handleDelete(hw.id)}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            {/* Add / Edit Modal */}
            {showModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {editingHomework ? 'Edit Homework' : 'Add Homework'}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseModal}
                                />
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="modal-body">
                                      <div className="mb-3">
                                       <div className="form-floating form-floating-outline">
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="date"
                                            value={formData.dueDate}
                                            onChange={handleChange}
                                            required
                                        />
                                         <label>Date</label>
                                       </div>
                                    </div>
                                      <div className="mb-3">
                                       <div className="form-floating form-floating-outline">
                                       <select name="homework" className='form-select'>
                                        <option disabled selected>Select Work Type</option>
                                        <option value="vaction">Vacation</option>
                                        <option value="class">Class Work</option>
                                        <option value="home">Home Work</option>
                                       </select>
                                         <label>Home Work Type</label>
                                       </div>
                                    </div>
                                      <div className="mb-3">
                                       <div className="form-floating form-floating-outline">
                                       <select name="homework" className='form-select'>
                                        <option disabled selected>Select Class</option>
                                        <option value="vaction">Vacation</option>
                                        <option value="class">Class Work</option>
                                        <option value="home">Home Work</option>
                                       </select>
                                         <label>Class</label>
                                       </div>
                                    </div>
                                     <div className="mb-3">
                                       <div className="form-floating form-floating-outline">
                                        <select className='form-select' name="subjects">

                                            <option value="">Select Subjects</option>
                                        </select>
                                         <label>Subject</label>
                                       </div>
                                    </div>


                                    <div className="mb-3">
                                       <div className="form-floating form-floating-outline">
                                        <input
                                            type="text"
                                            className="form-control input-capitalize"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleChange}
                                            required
                                        />
                                         <label>Home Work Title</label>
                                       </div>
                                    </div>
                                   
                                  
                                    <div className="mb-3">
                                       <div className="form-floating form-floating-outline">
                                        <textarea
                                            className="form-control input-uppercase"
                                            name="description"
                                            rows="3"
                                            value={formData.description}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                         <label>Home Work</label>
                                       </div>
                                    </div>
                                    <div className="mb-3">
                                       <div className="form-floating form-floating-outline">
                                       <select className='form-select' name="" id="">
                                        <option value="">Select Status</option>
                                        <option value="">Publish</option>
                                        <option value=""> Draft</option>
                                       </select>
                                         <label>Status</label>
                                       </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={handleCloseModal}
                                    >
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        {editingHomework ? 'Update' : 'Add'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default HomeWork;
